/* eslint-disable max-len */

export const englishDictionary = `
{
  "processingPayment": "Processing Payment",
  "cameraPermission": "If you want to grant permission for using your camera, enable it in the app settings",
  "noRidesAvailable": "You have no rides available",
  "errorOccurred": "An error occurred",
  "temporaryUnavailable": "Temporary unavailable",
  "authWithDriver": "Authenticate failed: check with your driver",
  "invalidQrCode": "Invalid QR Code",
  "rideValidated": "Ride Validated",
  "failedImage": "Failed to load image",
  "search": "Search",
  "enterEmail": "Enter your registered Email ID below.",
  "passwordLink": "A password reset link will be sent to your Email ID.",
  "appTitle": "Parknha",
  "appSlogan": "Your Digital Valet",
  "create": "Create Account",
  "upgrade": "Upgrade Your account to unlock Loyalty Points, Online Payment and save your rides",
  "email": "Email Id",
  "oldPass": "Old Password",
  "newPassword": "New Password",
  "confirmPassword": "Confirm Password",
  "passwordNoMatch": "Passwords do not match",
  "passwordUpdated": "Password updated successfully",
  "password": "Password",
  "fName": "First Name",
  "lName": "Last Name",
  "lPoints": "Loyalty Points",
  "history": "History",
  "vHistory": "History",
  "invoices": "Invoices",
  "account": "Account",
  "changePass": "Change Password",
  "forgotPass": "Forgot Password",
  "extras": "Extras",
  "pPolicy": "Privacy Policy",
  "byCreatingYouAgreeP": "By creating an account, you agree to our",
  "rIssue": "Report Issue",
  "share": "Share App",
  "logout": "Sign Out",
  "logoutText": "Are you sure you want to signout from the app ?",
  "verified": "Verified",
  "notVerified": "Not Verified",
  "verifyEmail": "Verify Email",
  "sendEmailVerification": "Send Link",
  "continue": "Continue",
  "next": "Next",
  "cancel": "Cancel",
  "sendingEmail": "Sending Email",
  "phoneRequired": "Phone is required",
  "phoneInvalid": "Phone number is not valid",
  "myMessages": "My Messages",
  "sending": "Sending",
  "cantSignOut": "To sign out, complete your ride first",
  "emailSent": "Email sent, please check your inbox",
  "wSlideOneTitle": "Scan QR Code",
  "GenerateCheckIn": "Generate your valet ticket to check in",
  "wSlideOneSubTitle": "When arriving at your destination, open your camera by clicking the QR code button. $$ Scan the valet driver's code to receive your ticket.",
  "wSlideTwoTitle": "Pre-order your car",
  "wSlideTwoSubTitle": "You can now pre-order your car at anytime. $$ Just relax as you will be notified and you will find it waiting for you.",
  "wSlideThreeTitle": "Validate or Pay",
  "wSlideThreeSubTitle": "Choose your payment method or scan the shop's QR code to validate your valet ticket for a free parking $$ Don't forget to rate your valet driver and tip him. They'll appreciate it!",
  "getStared": "Get Started",
  "login": "Sign In",
  "register": "Register",
  "createAccount": "Create an Account",
  "creatingAccount": "Creating Account",
  "forgotPass": "Forgot Password",
  "alreadyHaveAccount": "Already have an account?",
  "noAccount": "Don't have an account?",
  "fillAllFields": "Please fill all required fields",
  "enterValidEmail": "Please enter a valid email",
  "phoneNumber": "Phone Number",
  "dateOfBirth": "Date of Birth",
  "gender": "Gender",
  "checkIn": "Check In",
  "checkedIn": "Checked In",
  "creatingTicket": "Creating Ticket...",
  "profileUpdated": "Your profile was updated successfully",
  "updateProfile": "Update Profile",
  "editProfile": "Edit Profile",
  "uploadingImage": "Uploading Image",
  "updating": "Updating",
  "emailEnteredDoNotMatch": "The email you entered does not match your email",
  "emailAlreadyVerified": "Your email is already verified!",
  "changeMail": "Change Email Address",
  "emailUpdated": "Your email has been updated successfully",
  "currenPassword": "Current Password",
  "male": "Male",
  "female": "Female",
  "welcomeTo": "Welcome to",
  "ticketIdLabel": "Ticket ID",
  "driverName": "Driver Name",
  "checkInDate": "Check In Date",
  "requestCar": "Request My Car",
  "or": "OR",
  "validationCode": "Enter Validation Code",
  "downloadApp": "Download App",
  "invalidCode": "Invalid Code",
  "upgradeAccount": "Sign Up",
  "update": "Change Password",
  "name": "Full Name",
  "accountUpdated": "Account Updated Successfully",
  "payCash": "Pay Cash",
  "payCard": "Pay Card",
  "validate": "Scan the venue QR code to validate!",
  "recommendation": "Recommendation",
  "recommendationText": "It is recommended to validate your email before paying online",
  "understood": "I Understand",
  "addTip": "Add a tip",
  "noTip": "Don't add a tip",
  "tipAmount": "Tip Amount (AED)",
  "noAcceptCard": "Venue does not accept card payments",
  "noAcceptCash": "Venue does not accept cash payments",
  "status": "Status",
  "carBeingParked": "Your car is being parked",
  "guestWarning": "don't close the browser tab !",
  "guestWarning2": "Please don't close the browser tab",
  "allowEmailNots": "Allow email notifications",
  "allowSmsNots": "Allow SMS notifications",
  "continueWithCurrentAccount": "Continue with my account",
  "continueAsGuest": "Continue as guest (session available)",
  "loginOtherAccount": "Sign in to another account",
  "loginOrRegister": "Sign in or register",
  "continueGuest": "Continue as guest",
  "googleLogin": "Sign in with Google",
  "upgradeAccountBeforePay": "You cannot pay online without upgrading your account",
  "validationSuccess": "Code has been validated successfully",
  "validationStart": "Validating your code..",
  "upgradeWithGoogle": "Sign Up With Google",
  "floor": "Floor",
  "confirmRequest": "Confirm Request",
  "requestCarUpdateUser": "To request your car, please choose one the following options",
  "freeParking":"Free Parking?",
  "freeParkingAsk":"Ask the venue to validate your ticket.",
  "keyNote":"Please, leave your keys in the car",
  "rateUs": "Rate us",
  "rateExperience": "Rate Your Experience",
  "submitRate": "Submit",
  "GiveFeedback": "Give us your feedback",
  "browseShops":"Browse Shops",
  "language":"Language",
  "changeLanguage":"Change Language",
  "tipCannotBeZero":"Whoops! Your tip cannot be 0 AED or less",
  "assigningDriver":"Assigning a driver",
  "payByCardMessage":"If you want to pay by card you have to use an account",
  "congratsYourCarValidated":"Congrats! Your valet parking is for free!",
  "qrScanner": "QR Scanner",
  "noHistory": "You have no history!",
  "back": "Back",
  "reviewed": "Reviewed",
  "notReviewed": "Not Reviewed",
  "parkingAmenities": "Parking Amenities",
  "ourShops": "Our Shops",
  "privacyPolicy": "Privacy Policy",
  "recoverPass": "Please check the Junk/Spam folder in your email if you couldn't find the reset link email.",
  "saveToWhatsapp": "Save to WhatsApp",
  "saveToWhatsappHint": "Keep your ticket safe even if you close the browser page — come back anytime to request your car through the link in the Whatsapp chat",
  "openInWhatsapp": "Open in WhatsApp",
  "carWaitTime": "Your car can wait for {0} minutes",
  "dropOffLocation": "Drop Off Location",
  "requestTime": "Request Time",
  "carArrivedTime": "Car Arrived Time",
  "carWaitingOutside": "Your car is waiting outside",
  "keysInsideValetMessage": "Keys are inside. Your valet is now assisting another guest.",
  "profileTab": "Profile",
  "chatWithValet": "Chat with Valet",
  "payInvoice": "Pay Invoice",
  "chat": "Chat",
   "typeHere": "Type Here",
   "submittingReview": "Submitting Review",
   "loginRequiredForFreeRide": "This venue requires you to sign in to request a free ride",
   "quickReply1": "Where is my car?",
   "quickReply2": "How long will it take?",
   "quickReply3": "I'm waiting for you",
   "quickReply4": "Thank you!",
   "yourCarIsParked": "Your car is parked",
   "readyWheneverYouAre": "Ready whenever you are",
   "yourCarIsBeingParked": "Your car is being parked",
   "hangTight": "Hang tight — we'll update you here",
   "availableWhenParked": "Available once your car is parked",
   "tapWhenReady": "Tap when you're ready to leave"
}`;

export const arabicDictionary = `
{
  "processingPayment": "معالجة الدفع",
  "cameraPermission": "إذا كنت ترغب في منح الإذن لاستخدام الكاميرا، قم بتمكينه في إعدادات التطبيق",
  "noRidesAvailable": "لا توجد رحلات متاحة",
  "errorOccurred": "حدث خطأ",
  "authWithDriver": "فشل التحقق: تحقق مع سائقك",
  "invalidQrCode": "رمز الاستجابة السريعة غير صالح",
  "rideValidated": "تم التحقق من الرحلة",
  "failedImage": "فشل في تحميل الصورة",
  "temporaryUnavailable": "غير متوفر مؤقتًا",
  "search": "بحث",
  "enterEmail": ".أدخل البريد الإلكتروني المسجل أدناه",
  "passwordLink": ".سيتم إرسال رابط إعادة تعيين كلمة المرور إلى البريد الإلكتروني الخاص بك",
  "forgotPass": "استرجاع كلمة المرور",
  "appTitle": "باركنها",
  "appSlogan": "خادمك الرقمي",
  "create": "إنشاء حساب",
  "upgrade": "ترقية حسابك للفوز بنقاط الولاء والدفع عبر الإنترنت وحفظ رسوماتك",
  "email": "البريد الإلكتروني",
  "oldPass": "كلمة المرور القديمة",
  "newPassword": "كلمة المرور الجديدة",
  "confirmPassword": "تأكيد كلمة المرور",
  "passwordNoMatch": "كلمات المرور غير متطابقة",
  "passwordUpdated": "تم تحديث كلمة المرور بنجاح",
  "password": "كلمة السر",
  "fName": "الاسم الأول",
  "lName": "اسم العائلة",
  "lPoints": "نقاط الولاء",
  "history": "سجل النشاط",
  "vHistory": "تاريخ المعاملات",
  "invoices": "الفواتير",
  "account": "الحساب",
  "changePass": "تغيير كلمة المرور",
  "extras": "إضافات",
  "pPolicy": "سياسة الخصوصية",
  "byCreatingYouAgreeP": "من خلال إنشاء حساب ، فإنك توافق على ",
  "rIssue": "الإبلاغ عن مشكلة",
  "share": "مشاركة التطبيق",
  "logout": "تسجيل الخروج",
  "logoutText": "التأكيد على تسجيل الخروج من التطبيق ؟",
  "verified": "مؤكد",
  "notVerified": "غير مؤكد",
  "verifyEmail": "التحقق من البريد الإلكتروني",
  "sendEmailVerification": "إرسال بريد إلكتروني",
  "continue": "متابعة",
  "next": "متابعة",
  "cancel": "إلغاء",
  "sendingEmail": "البريد الإلكتروني في طريقه",
  "phoneRequired": "الهاتف مطلوب",
  "phoneInvalid": "رقم الهاتف غير صالح",
  "myMessages": "رسائلي",
  "sending": "يتم الآن الإرسال",
  "cantSignOut": "لتسجيل الخروج ، أكمل رحلتك أولاً",
  "emailSent": "تم إرسال البريد الإلكتروني، الرجاء التحقق من علبة الوارد الخاصة بك",
  "wSlideOneTitle": "فحص رمز الاستجابة السريعة",
  "GenerateCheckIn": "قم بإنشاء تذكرة خادمك لتسجيل الوصول",
  "wSlideOneSubTitle": "عند الوصول إلى وجهتك ، افتح الكاميرا بالنقر فوق زر رمز الاستجابة السريعة. $$ امسح رمز السائق لاستلام تذكرتك",
  "wSlideTwoTitle": "طلب سيارتك مسبقا",
  "wSlideTwoSubTitle": "يمكنك طلب سيارتك مسبقا في أي وقت. فقط استرخي بينما وصلت . $$ سيتم إعلامك وستجدها بانتظارك",
  "wSlideThreeTitle": "الحصول على طابع أو دفع",
  "wSlideThreeSubTitle": "اختر طريقة الدفع الخاصة بك أو امسح رمز المتجر للتحقق من صحة تذكرة خادمك للحصول على موقف سيارات مجاني $$ لا تنسى تقييم سائق خادمك وإعطائه إكرامية. سوف يقدرون ذلك",
  "getStared": "البدء",
  "login": "تسجيل الدخول",
  "register": "إنشاء حساب",
  "createAccount": "إنشاء حساب",
  "creatingAccount": "جاري إنشاء حساب",
  "forgotPass": "هل نسيت كلمة المرور ؟",
  "alreadyHaveAccount": "هل لديك حساب ؟",
  "noAccount": "ليس لديك حساب ؟ ",
  "fillAllFields": "يرجى تعبئة جميع الحقول المطلوبة",
  "enterValidEmail": "يرجى إدخال البريد الإلكتروني الصحيح",
  "phoneNumber": "رقم الهاتف",
  "dateOfBirth": "تاريخ الولادة",
  "gender": "الجنس",
  "checkIn": "إدخال السيارة",
  "checkedIn": "مسجل",
  "creatingTicket": "نيجري إنشاء التذكرة...",
  "profileUpdated": "تم تحديث ملف التعريف الخاص بك بنجاح",
  "updateProfile": "تحديث الملف",
  "editProfile": "تعديل الملف",
  "uploadingImage": "يتم تحميل الصورة",
  "updating": "يتم التحديث",
  "emailEnteredDoNotMatch": "البريد الإلكتروني الذي أدخلته لا يتطابق مع بريدك الإلكتروني",
  "emailAlreadyVerified": "تم التحقق من بريدك الإلكتروني بالفعل!",
  "changeMail": "تغيير البريد الالكتروني",
  "emailUpdated": "تم تحديث بريدك الإلكتروني بنجاح",
  "currenPassword": "كلمة المرور الحالي",
  "male": "ذكر",
  "female": "أنثى",
  "welcomeTo": "مرحبا بك في",
  "ticketIdLabel": "رقم التذكرة",
  "driverName": "اسم السائق",
  "checkInDate": "تاريخ الدخول",
  "requestCar": "اطلب سيارتي",
  "or": "أو",
  "validationCode": "أدخل رمز التأكيد",
  "downloadApp": "تحميل التطبيق",
  "invalidCode": "الرمز غير صحيح",
  "upgradeAccount": "حدث الحساب",
  "update": "تعديل كلمة المرور",
  "name": "الاسم بالكامل",
  "accountUpdated": "تم تحديث الحساب بنجاح",
  "payCash": "ادفع نقدا",
  "payCard": "ادفع بالبطاقة",
  "validate": "الحصول على ختم",
  "recommendation": "توصية",
  "recommendationText": "يوصى بالتحقق من صحة بريدك الإلكتروني قبل الدفع عبر الإنترنت",
  "understood": "أفهم العواقب",
  "addTip": "إضافة تيب",
  "noTip": "متابعة",
  "tipAmount": "المبلغ (درهم)",
  "noAcceptCard": "المكان لا يقبل الدفع بالبطاقات",
  "noAcceptCash": "المكان لا يقبل المدفوعات النقدية",
  "status": "حالة السيارة الان",
  "carBeingParked": "يتم إيقاف سيارتك",
  "guestWarning": "لا تغلق علامة تبويب المتصفح",
  "guestWarning2": "من فضلك لا تغلق علامة تبويب المتصفح",
  "allowEmailNots": "السماح بإخطارات البريد الإلكتروني",
  "allowSmsNots": "السماح بإشعارات الرسائل القصيرة",
  "continueWithCurrentAccount": "تسجيل الدخول بحسابي الحالي",
  "continueAsGuest": "تسجيل الدخول كضيف",
  "loginOtherAccount": "تسجيل الدخول إلى حساب آخر",
  "loginOrRegister": "تسجيل الدخول أو انشاء حساب",
  "continueGuest": "تسجيل الدخول كضيف",
  "googleLogin": "الدخول مع جوجل",
  "upgradeAccountBeforePay": "لا يمكنك الدفع عبر الإنترنت دون ترقية حسابك",
  "validationSuccess": "تم التحقق من صحة الرمز بنجاح",
  "validationStart": "يتم التحقق من صحة الرمز...",
  "upgradeWithGoogle": "ترقية الحساب مع جوجل",
  "floor": "الطابق",
  "confirmRequest": "تأكيد الطلب",
  "requestCarUpdateUser": "لطلب سيارتك ، يرجى اختيار أحد الخيارات التالية",
  "freeParking":"موقف سيارات مجاني؟ ",
  "freeParkingAsk":"اطلب من المكان التحقق من صحة تذكرتك",
  "keyNote":"من فضلك ، اترك مفاتيحك في السيارة",
   "rateUs": "تقييم",
   "rateExperience": "قيم تجربتك",
   "submitRate": "تقديم",
   "GiveFeedback": "أعطنا تقييمك",
   "browseShops":"تصفح المحلات التجارية",
   "language":"اللغة",
   "changeLanguage":"تغيير اللغة",
   "tipCannotBeZero":" عذرًا! لا يمكن أن تكون إكرامية 0 درهم أو أقل",
   "assigningDriver":"تعيين سائق",
   "payByCardMessage":"للدفع عن طريق البطاقه يجب ان تقوم تدخل لحسابك",
   "congratsYourCarValidated":"تهاني! خدمة صف السيارات الخاصة بك مجانية",
   "qrScanner": "فاحص رمز الاستجابة السريعة",
   "noHistory":  "!ليس لديك سجل معاملات",
   "back": "الرجوع",
   "reviewed": "تمت المراجعة",
   "notReviewed": "لم تتم المراجعة",
   "parkingAmenities": "خدمات المواقف",
   "ourShops": "محلاتنا",
   "profileTab": "الملف الشخصي",
   "privacyPolicy": "سياسة الخصوصية",
   "recoverPass": ".يرجى التحقق من مجلد البريد العشوائي في بريدك الإلكتروني إذا لم تتمكن من العثور على رابط إعادة تعيين كلمة المرور",
  "saveToWhatsapp": "حفظ في واتساب",
  "saveToWhatsappHint": "احتفظ بتذكرتك بأمان حتى لو أغلقت المتصفح — عد في أي وقت لطلب سيارتك عن طريق الضغط على الرابط في الواتساب",
   "openInWhatsapp": "فتح في واتساب",
   "carWaitTime": "يمكن لسيارتك الانتظار لمدة {0} دقائق",
   "dropOffLocation": "موقع التوصيل",
   "requestTime": "وقت الطلب",
   "carArrivedTime": "وقت وصول السيارة",
   "carWaitingOutside": "سيارتك بانتظارك في الخارج",
   "keysInsideValetMessage": "المفاتيح بداخل السيارة. السائق الآن يساعد ضيفاً آخر.",
   "chatWithValet": "التحدث مع السائق",
   "payInvoice": "دفع الفاتورة",
   "chat": "الدردشة",
   "typeHere": "اكتب هنا",
   "submittingReview": "جاري إرسال التقييم",
   "loginRequiredForFreeRide": "يطلب هذا المكان تسجيل الدخول لطلب خدمة مجانية",
   "quickReply1": "أين سيارتي؟",
   "quickReply2": "كم من الوقت سيستغرق؟",
   "quickReply3": "أنا بانتظارك",
   "quickReply4": "شكراً!",
   "yourCarIsParked": "سيارتك متوقفة",
   "readyWheneverYouAre": "جاهزون متى ما كنت مستعدًا",
   "yourCarIsBeingParked": "سيارتك قيد الإيقاف",
   "hangTight": "انتظر قليلاً — سنخبرك هنا",
   "availableWhenParked": "متاح حالما يتم إيقاف سيارتك",
   "tapWhenReady": "اضغط عندما تكون مستعدًا للمغادرة"
  }`;
